import React from "react"

import InnerAndOuterLengthConfigurationInput from "components/Configurations/InnerAndOuterLengthConfigurationInput"
import OuterLengthConfigurationInput from "components/Configurations/OuterLengthConfigurationInput"
import SystemAndLengthCombinationConfigurationInput from "components/Configurations/SystemAndLengthCombinationConfigurationInput"
import SystemAndOuterLengthConfigurationInput from "components/Configurations/SystemAndOuterLengthConfigurationInput"
import SystemConfigurationInput from "components/Configurations/SystemConfigurationInput"

import { ProductAttributes } from "@secureo/common/typings/Product"

const EditLockingSystemComponentConfigurations = ({
	isLoading,
	disabled = false,
	attributes,
	selectedSystem,
	selectedOuterLength,
	selectedInnerLength,
	setSelectedSystem,
	setSelectedOuterLength,
	setSelectedInnerLength,
}: Props) => {
	const {
		innerLengthsByOuterLengths,
		lengthCombinationsBySystem,
		outerLengthsBySystem,
		outerLengths,
		systems,
	} = attributes

	if (innerLengthsByOuterLengths)
		return (
			<InnerAndOuterLengthConfigurationInput
				disabled={isLoading || disabled}
				innerLengthsByOuterLengths={innerLengthsByOuterLengths}
				selectedOuterLength={selectedOuterLength}
				selectedInnerLength={selectedInnerLength}
				onOuterLengthChange={setSelectedOuterLength}
				onInnerLengthChange={setSelectedInnerLength}
				margin="none"
			/>
		)

	if (lengthCombinationsBySystem)
		return (
			<SystemAndLengthCombinationConfigurationInput
				disabled={isLoading || disabled}
				lengthCombinationsBySystem={lengthCombinationsBySystem}
				selectedSystem={selectedSystem}
				selectedOuterLength={selectedOuterLength}
				selectedInnerLength={selectedInnerLength}
				onSystemChange={setSelectedSystem}
				onOuterLengthChange={setSelectedOuterLength}
				onInnerLengthChange={setSelectedInnerLength}
				margin="none"
			/>
		)

	if (outerLengthsBySystem)
		return (
			<SystemAndOuterLengthConfigurationInput
				disabled={isLoading || disabled}
				outerLengthsBySystem={outerLengthsBySystem}
				selectedSystem={selectedSystem}
				selectedOuterLength={selectedOuterLength}
				onSystemChange={setSelectedSystem}
				onOuterLengthChange={setSelectedOuterLength}
				margin="none"
			/>
		)

	if (outerLengths)
		return (
			<OuterLengthConfigurationInput
				disabled={isLoading || disabled}
				outerLengths={outerLengths}
				selectedOuterLength={selectedOuterLength}
				onOuterLengthChange={setSelectedOuterLength}
				margin="none"
			/>
		)

	if (systems)
		return (
			<>
				<SystemConfigurationInput
					disabled={isLoading || disabled}
					systems={systems}
					selectedSystem={selectedSystem}
					onSystemChange={setSelectedSystem}
					showLabel={false}
					margin="none"
					isLockingSystem={true}
				/>
			</>
		)

	return null
}

interface Props {
	isLoading: boolean
	disabled?: boolean
	attributes: ProductAttributes
	selectedSystem: string
	selectedOuterLength: number
	selectedInnerLength: number
	setSelectedSystem?: (selectedSystem: string) => void
	setSelectedOuterLength?: (selectedOuterLength: number) => void
	setSelectedInnerLength?: (selectedInnerLength: number) => void
}

export default EditLockingSystemComponentConfigurations
